import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
// import components
import InformationCard from '../elements/InformationCard'

const DemoSession = (props) => {

  return(
    <div>
      <InformationCard 
        items={props.items}
      />
    </div>
  )
}

export default DemoSession;